export const SET_CATEGORY = 'SET_CATEGORY';
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const POST_CATEGORY = 'POST_CATEGORY';
export const GET_CAT_RELATED_FAILURE = 'GET_CAT_RELATED_FAILURE';
export const GET_CAT_RELATED_SUCCESS = 'GET_CAT_RELATED_SUCCESS';
export const GET_ALL_CATEGORIES_FAILURE = 'GET_ALL_CATEGORIES_FAILURE';
export const GET_ALL_CATEGORIES_SUCCESS = 'GET_ALL_CATEGORIES_SUCCESS';
export const RESET_CATEGORY_STATUS = 'RESET_CATEGORY_STATUS';

